import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useHasCapabilityBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonNotesAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonNotes = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonNotes
  });

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonNotes });

  return {
    loaded,
    canViewPersonNotes
  };
}
